import { FC, useMemo } from 'react';
import Modal from '@srm/ui/modal';
import Button from '@srm/ui/button';
import { IDocumentTable, IMergeRows } from '@models/Forms/IForms';
import TableData from '@organisms/TableData';
import { deriveTableWithColumns, TableRow } from './tableColumns';
import { buildMergeGroups, mergePreviewRows, mergeResultRows } from './tableMergeSplit';

/** «Объединение строк»: предпросмотр групп (исходные строки — в раскрываемом
 *  детейле результата) и применение. Замена MergeRowsForm без DX: превью
 *  рендерит TableData, итог получает uuid-|NUM (легаси ставила целые). */
const MergeRowsModal: FC<{
    table: IDocumentTable;
    settings: IMergeRows;
    rows: TableRow[];
    onApply: (merged: TableRow[]) => void;
    onClose: () => void;
}> = ({ table, settings, rows, onApply, onClose }) => {
    const groups = useMemo(() => buildMergeGroups(rows, settings), [rows, settings]);
    const previewRows = useMemo(() => mergePreviewRows(groups), [groups]);

    const previewTable = useMemo<IDocumentTable>(
        () =>
            deriveTableWithColumns(table, {
                id: `${table.id ?? table.key}-merge`,
                tableColumn: settings.columns?.tableColumn ?? [],
                tables: [],
            }),
        [table, settings],
    );

    return (
        <Modal
            size="max"
            onClose={onClose}
            header="Объединение строк"
            footer={
                <div className="modal-dlg-buttons">
                    <Button
                        variant="primary"
                        size="sm"
                        aria-label="Применить объединение"
                        onClick={() => {
                            onApply(mergeResultRows(groups));
                            onClose();
                        }}
                    >
                        Применить
                    </Button>
                    <Button variant="light" size="sm" aria-label="Отменить объединение" onClick={onClose}>
                        Отменить
                    </Button>
                </div>
            }
        >
            <TableData
                table={previewTable}
                rows={previewRows}
                canExpandRow={(row) => Array.isArray(row['|Merged'])}
                renderDetail={(row) =>
                    Array.isArray(row['|Merged']) ? (
                        <TableData
                            table={{ ...previewTable, id: `${previewTable.id}-src` } as IDocumentTable}
                            rows={row['|Merged'] as TableRow[]}
                            compact
                        />
                    ) : null
                }
            />
        </Modal>
    );
};

export default MergeRowsModal;
